// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kChQ","input":"styles_input__2AmWU"};